import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SearchResultsTable from '../components/SearchResultsTable';
import {fetchPresets, onDeletePreset, onSetUserPreferredPreset} from '../actions/PresetActions';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import Error from '../components/Error';
import Loading from '../components/Loading';
import {Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import PresetNumberModalButton from '../components/PresetNumberModalButton';

@connect(state => ({presets: state.presets, user: state.auth.currentUser}), {fetchPresets, onDeletePreset, onSetUserPreferredPreset})
export default class PresetsContainer extends Component {
    static propTypes = {
        fetchPresets: PropTypes.func,
        user: PropTypes.object,
        onDeletePreset: PropTypes.func,
        presets: PropTypes.shape({
            loading: PropTypes.bool,
            error: PropTypes.object,
            items: PropTypes.object
        }),
        history: PropTypes.object,
        onSetUserPreferredPreset: PropTypes.func,
    };

    componentDidMount() {
        this.props.fetchPresets();
    }

    handleDelete = (id) => {
        this.props.onDeletePreset(id);
    };

    handleRowClick = (id) => {
        this.props.history.push(`/preset/${id}`);
    };

    handleSetPreferredPreset = (amplitude, spread, e) => {
        e.stopPropagation();
        this.props.onSetUserPreferredPreset(amplitude, spread);
    };

    render() {
        const {presets, user} = this.props;
        if (isEmpty(presets)) {
            return false;
        }
        const {loading, error, items} = presets;
        if (!isEmpty(error)) {
            return <Error error={error}/>;
        }
        if (loading) {
            return <Loading/>;
        }
        const headers = [
            {path: 'id', label: 'Id'},
            {path: 'name', label: 'Name'},
            {path: 'amplitude', label: 'Amplitude'},
            {path: 'spread', label: 'Spread'},
        ];

        const PreferredButtonComponent = ({rowData}) => (
            <Button
                title="Set as default preferred preset"
                bsStyle="default"
                className={classNames({preferred: (items[rowData.id].amplitude === user.preferredAmplitude && items[rowData.id].spread === user.preferredSpread)})}
                onClick={(e) => {
                    this.handleSetPreferredPreset(items[rowData.id].amplitude, items[rowData.id].spread, e)
                }}>
                <i className="fa fa-thumbs-up"/>
            </Button>
        );

        const PresetNumberButtonComponent = ({rowData}) => (
            <PresetNumberModalButton
                buttonLabel={items[rowData.id].presetNumber || '_'}
                buttonTitle={'Change preset number'}
                presetId={rowData.id}
                editableName={false}
                showMatchingWarning={false}
                modalTitle={'Re-assign preset number'}
            />
        );

        const extraColumnMetadata = [
            {
                displayName: '',
                columnName: '_preferred_',
                visible: true,
                cssClassName: 'preferred-col',
                customComponent: PreferredButtonComponent
            },
            {
                displayName: 'Number',
                columnName: '_number_',
                order: 0.5,
                visible: true,
                cssClassName: 'preset-number-col',
                customComponent: PresetNumberButtonComponent
            },
        ];

        return (
            <div className="page">
                <div className="page_contents" style={{width: 1400}}>
                    <h1>{'Presets'}</h1>
                    <div className="card" style={{minHeight: 600}}>
                        <Link to="/preset">
                            <Button bsStyle="success" style={{marginBottom: 20}}>
                                <i className="fa fa-plus"/>
                                {' Create new preset'}
                            </Button>
                        </Link>
                        <SearchResultsTable
                            headers={headers}
                            results={orderBy(items, 'id')}
                            onDelete={this.handleDelete}
                            onRowClick={this.handleRowClick}
                            extraColumnMetadata={extraColumnMetadata}
                            resultsPerPage={20}
                            nameGetter={d => `preset '${d.name}'`}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PresetsContainer.js